var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdd({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 15.5,
    stroke: "#DBDCDC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.6062 16.3938L10.8455 16.3938C10.6537 16.3938 10.4969 16.2381 10.5 16.0463C10.5008 16.0034 10.5016 15.9789 10.5024 15.9639C10.5128 15.7689 10.6592 15.608 10.8545 15.608L15.6062 15.608L15.6062 10.8473C15.6062 10.6555 15.7617 10.5 15.9535 10.5L16.0447 10.5C16.2365 10.5 16.392 10.6555 16.392 10.8473L16.392 15.608L21.1527 15.608C21.3445 15.608 21.5 15.7635 21.5 15.9553V16.0465C21.5 16.2383 21.3445 16.3938 21.1527 16.3938L16.392 16.3938L16.392 21.1545C16.392 21.3463 16.2363 21.5031 16.0445 21.5C16.0015 21.4992 15.977 21.4984 15.9621 21.4976C15.767 21.4872 15.6062 21.3408 15.6062 21.1455L15.6062 16.3938Z",
    fill: "#FEFEFE",
    stroke: "#FEFEFE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdd);
export default __webpack_public_path__ + "static/media/Add.7b4d59c3.svg";
export { ForwardRef as ReactComponent };var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdd({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 15.5,
    stroke: "#DBDCDC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.6062 16.3938L10.8455 16.3938C10.6537 16.3938 10.4969 16.2381 10.5 16.0463C10.5008 16.0034 10.5016 15.9789 10.5024 15.9639C10.5128 15.7689 10.6592 15.608 10.8545 15.608L15.6062 15.608L15.6062 10.8473C15.6062 10.6555 15.7617 10.5 15.9535 10.5L16.0447 10.5C16.2365 10.5 16.392 10.6555 16.392 10.8473L16.392 15.608L21.1527 15.608C21.3445 15.608 21.5 15.7635 21.5 15.9553V16.0465C21.5 16.2383 21.3445 16.3938 21.1527 16.3938L16.392 16.3938L16.392 21.1545C16.392 21.3463 16.2363 21.5031 16.0445 21.5C16.0015 21.4992 15.977 21.4984 15.9621 21.4976C15.767 21.4872 15.6062 21.3408 15.6062 21.1455L15.6062 16.3938Z",
    fill: "#FEFEFE",
    stroke: "#FEFEFE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdd);
export default __webpack_public_path__ + "static/media/Add.7b4d59c3.svg";
export { ForwardRef as ReactComponent };